<form name="addPlaylistForm" #form="ngForm">

	<section layout="row" [ngClass]="styles.wrapper">

		<vb-ui-checkbox name="isSelected" flex-align-self="center" [hidden]="playlist.id" [ngClass]="styles.chkBox" [(ngModel)]="playlist.isSelected">
		</vb-ui-checkbox>

		<input type="text" flex="1 1 0" name="playlistName" [ngClass]="styles.playlistName" [attr.aria-label]="'Media_Videos_Playlists_NewPlaylist' | translate " [placeholder]="'Media_Videos_Playlists_NewPlaylist' | translate " [(ngModel)]="playlist.name" #playlistName="ngModel" trim="blur" required vbUiTextInput/>

		<vb-loading-spinner class="margin-right-10" [ngClass]="styles.spinner" [hidden]="!isCreatingPlaylist" [size]="'small'">
		</vb-loading-spinner>

		<section [hidden]="isCreatingPlaylist">
			<button type="button" class="margin-right-5" [ngClass]="styles.btn" [attr.aria-label]="'Media_Videos_Playlists_CreatePlaylist' | translate" [disabled]="form.invalid" (click)="createPlaylist()" vbUiBtnPrimaryNgx>
				<span class="glyphicons ok_2"></span>
			</button>
			<button type="button" [ngClass]="styles.btn" [attr.aria-label]="'Media_Videos_Playlists_CancelCreatePlaylist' | translate" (click)="cancelCreatePlaylist()" vbUiBtnSecondaryNgx>
				<span class="glyphicons remove_2"></span>
			</button>
		</section>

		<div *ngIf="!playlistName.pristine && playlistName.invalid" flex="100" role="alert" vbUiErrorMessage>
			<div *ngIf="playlistName.errors?.required">{{ 'ThisFieldIsRequired' | translate }}</div>
		</div>

	</section>

</form>